import "./Home.module.css";
import Header from "@/reusable_sections/Header";
import TopDollarHero from "./sections/TopDollarHero";
import OurPrintSolutions from "./sections/OurPrintSolutions";
import OurCorePhilosophy from "./sections/OurCorePhilosophy";
import TheStrategicEdge from "./sections/TheStrategicEdge";
import VoiceOfTheSupplyChain from "./sections/VoiceOfTheSupplyChain";
import BeginTheConversation from "./sections/BeginTheConversation";
import Gallery from "./sections/Gallery";
import Footer from "@/reusable_sections/Footer";
export default function HomePage() {
  return <div>
      <Header />
      <TopDollarHero />
      <OurPrintSolutions />
      <Gallery />
      <OurCorePhilosophy />
      <TheStrategicEdge />
      <VoiceOfTheSupplyChain />
      <BeginTheConversation />
      <Footer />
    </div>;
}